module.exports = __webpack_public_path__ + "img/tag_green_pin.5695c7bb.svg";